import { ACTION, FEATURE } from '../../../helpers/logger-enums';
import { createLogger } from '../../../helpers/loggerFacade';
import { FROM_PASSPORT } from '../enums';

const logger = createLogger('user-metrics');

export function checkForLoginSuccess() {
    const params = new URLSearchParams(document.location.search);
    if (!params.get(FROM_PASSPORT)) return;

    const withoutFlagUrl = new URL(document.location.href);
    withoutFlagUrl.searchParams.delete(FROM_PASSPORT);
    window.history.replaceState(null, '', withoutFlagUrl.toString());

    logger.featureEvent({
        feature: FEATURE.AUTHORIZATION,
        action: ACTION.LOGIN,
        isSuccess: true,
    });
}
